import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useModal from '../../../../hooks/use-close-modal.hook';
import Icon from '../../../../components/forms/icon.component';
import Button from '../../../../components/forms/button.component';
import { useTranslation } from 'react-i18next';

interface MailingTemplate {
  _id: string;
  account: {
    name: string;
    company: {
      name: string;
    };
  };
  name: string;
  html: string;
  status: boolean;
  created_at: string;
  updated_at: string;
}

interface PreviewModalProps {
  show: boolean;
  onRequestClose: () => void;
  template: MailingTemplate | null;
}

function PreviewModal({ show, onRequestClose, template }: PreviewModalProps) {
  const { t } = useTranslation();
  const modalRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useModal(modalRef, show);

  const handleEdit = () => {
    onRequestClose();
    setTimeout(() => {
      navigate(`/templates-panel/templates-mailing-builder`, {
        state: { template: template }
      });
    }, 100);
  };

  return (
    <div aria-hidden="true" className="modal fade" ref={modalRef} data-bs-backdrop="static">
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content max-h-900px">
          <div className="modal-header">
            <h5 className="modal-title d-flex align-items-center">
              <Icon icon="ki-eye" size="fs-2" type="primary" className="me-3" />
              {t('templates.mailing.table.preview')} - {template?.name}
            </h5>
            <button type="button" className="btn-close" onClick={onRequestClose}></button>
          </div>
          <div className="modal-body p-0">
            <div className="row g-0">
              <div className="col-12 p-6">
                <div className="border rounded p-4 bg-white overflow-hidden">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: template?.html ?? ''
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onRequestClose}>
              {t('general.close')}
            </button>
            <Button className="btn btn-primary" onClick={handleEdit}>
              <Icon icon="ki-pencil" size="fs-4" className="me-2" />
              {t('templates.mailing.builder.edit-title')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreviewModal;
